export default "__VITE_ASSET__C3r$pcns__"